import { render, staticRenderFns } from "./Blog-fooret.vue?vue&type=template&id=0337f84f&scoped=true&"
import script from "./Blog-fooret.vue?vue&type=script&lang=js&"
export * from "./Blog-fooret.vue?vue&type=script&lang=js&"
import style0 from "./Blog-fooret.vue?vue&type=style&index=0&id=0337f84f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337f84f",
  null
  
)

export default component.exports